export default __webpack_public_path__ + "static/media/wi-day-rain-wind.8c35a35b.svg";